import { render, staticRenderFns } from "./DetailChatPanel.vue?vue&type=template&id=78a76d2d&scoped=true"
import script from "./DetailChatPanel.vue?vue&type=script&lang=js"
export * from "./DetailChatPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailChatPanel.vue?vue&type=style&index=0&id=78a76d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a76d2d",
  null
  
)

export default component.exports